<!-- @format -->

<ng-container *transloco="let t">
  @if (selections$ | async; as selections) {
    <sis-combobox
      [placeholder]="t('SEARCH.PLACEHOLDER_SEARCH_OR_SELECT')"
      [selected]="selections"
      [options]="options"
      [label]="label"
      (optionChange)="onSelectionChange($event)">
    </sis-combobox>
  }
</ng-container>
